import logo1 from "./logo/logo.png";
import logo2 from "./logo/logo2.png";
import logo3 from "./logo/logo3.png";
import logo4 from "./logo/logo4.png";

const logoImages = { logo1, logo2, logo3, logo4 };
export default logoImages;